import type { GridBaseProps } from "@repo/ui";

import { KeyedArray, SortTypeEnum, IncidentStatus } from "@repo/models";
import { Checkbox, Column, FiltersV2, GridPreLoaded, LocalDateColumn, OriginalTimezoneDateColumn } from "@repo/ui";
import { useMemo, useState } from "react";

import type { EnrollmentValidationError } from "../../../models";

import { useEnrollmentValidationErrorApi } from "../../../api/eveAPI";
import { useRepContext } from "../../../contexts/editableItemContext";
import { EVETypeGrid } from "./typeGrid";

interface Props extends GridBaseProps<EnrollmentValidationError> {}

const COLUMNS = [
	// Unlike other columns, this should convert to local as its system saved so always saved in UTC.
	// The MVC UI's also convert to local, so this keeps it consistent.
	new LocalDateColumn("Incident Date", "incidentDate").dateOnly().withSortBy(SortTypeEnum.descending),
	new Column("Status", "status").withFormat((i) => IncidentStatus[i]),
	new Column("Enrollment Id", "enrollmentId"),
	new Column("Validation Name", "validationName"),
	new Column("QA Analyst", "qaAnalystName"),
	new OriginalTimezoneDateColumn("Assigned Date", "assignedDate").dateOnly(),
	new OriginalTimezoneDateColumn("Completed Date", "completedDate").dateOnly(),
] as Column<EnrollmentValidationError>[];

function ComplaintsGridBasic(props: Props) {
	const { repId } = useRepContext();
	const { useEVEsQuery } = useEnrollmentValidationErrorApi();
	const { data, loaded, clearQuery } = useEVEsQuery(repId);

	const [valid, setValid] = useState(false);
	const filteredData = useMemo(() => {
		if (!data?.any()) return new KeyedArray<EnrollmentValidationError>([], (i) => i.id);
		return data.filter((i) => !valid || i.valid === valid);
	}, [data, valid]);

	return (
		<>
			{renderFilters()}
			<GridPreLoaded
				{...props}
				id="eveGrid"
				pageSize={5}
				columns={COLUMNS}
				values={filteredData.data}
				loading={!loaded}
				getData={clearQuery}
			/>
			<EVETypeGrid />
		</>
	);

	function renderFilters() {
		return (
			<FiltersV2 className="mt-2">
				<Checkbox title="Valid Only" label="" value={valid} changeHandler={setValid} inline={false} />
			</FiltersV2>
		);
	}
}

export default ComplaintsGridBasic;
